import './styles.scss';

import { ReactElement, ReactNode } from 'react';

import ProgressBar from '@/common/ProgressBar';
import { ProgressBarTypes } from '@/common/ProgressBar/types';
import { getClasses } from '@/utils';

export interface DetailsProgressBarProps extends Partial<ProgressBarTypes.Props> {
  leftLabel?: ReactNode;
  rightLabel?: ReactNode;
  className?: string;
  name?: ReactNode;
}

const DetailsProgressBar = ({ leftLabel, rightLabel, className, name, ...progressProps }: DetailsProgressBarProps): ReactElement => {
  return (
    <div className={getClasses('DetailsProgressBar', className)}>
      <div className="DetailsProgressBar-Title">{name}</div>
      <div className="DetailsProgressBar-Container">
        <div className="DetailsProgressBar-LeftLabel text-primary">{leftLabel}</div>
        <div className="DetailsProgressBar-Bar">
          <ProgressBar {...(progressProps as ProgressBarTypes.Props)} variant="primary" />
        </div>
        <div className="DetailsProgressBar-RightLabel text-primary">{rightLabel}</div>
      </div>
    </div>
  );
};

export default DetailsProgressBar;
